// Default State
const state = {
    needsTotalsRefresh: false,
    postPrePaymentPerformed: false,
}
// Module Getters
const getters = {
    getCheckoutTotalsRefreshStatus: state => {
        return state.needsTotalsRefresh;
    },
    getPostPrePaymentPerformed: (state) => state.postPrePaymentPerformed,
}

// Module Actions
const actions = {
    resetPostPrePaymentPerformed({ commit }) {
        commit('setPostPrePaymentPerformed', false);
      },
}

// Module Mutations
const mutations = {
    updateCheckoutTotalsRefreshStatus ( state, payload ) {
        state.needsTotalsRefresh = payload;
    },
    setPostPrePaymentPerformed(state, value) {
        state.postPrePaymentPerformed = value;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
